import { useEffect, useMemo, useState } from "react";
import { paginate } from "../utils/paginate";

export const useClientPagination = ({
  data = [],
  pageSize = 10,
  resetKey,
}) => {
  const [page, setPage] = useState(1);

  // Reset page when category changes
  useEffect(() => {
    setPage(1);
  }, [resetKey]);

  const pagination = useMemo(() => {
    return paginate(data, page, pageSize);
  }, [data, page, pageSize]);

  return {
    ...pagination,
    page,
    setPage,
  };
};